import axios from 'axios'
import { useEffect, useState } from 'react'
import { useAuthState } from 'react-firebase-hooks/auth'
import auth from '../../firebase.init'
import Loader from '../Shared/Loader/Loader'

export default function MyOrder() {
    const [orders, setOrders] = useState([])
    const [user] = useAuthState(auth)
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        axios(`https://aesthetic-ware-house.herokuapp.com/api/orders?email=${user.email}`,{
            headers: {
                "content-type": "application/json",
                authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
        })
            .then(res => {
                setOrders(res.data)
                setLoading(false)
            })
    }, [user.email])
    return (
        <>
            {
                !loading ? (
                    <div className="container mx-auto">
                        <h1 className="text-center text-xl font-medium mb-5">My Order</h1>
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th>Order ID</th>
                                    <th>Product ID</th>
                                    <th>Product Name</th>
                                    <th>Quantity</th>
                                    <th>Price</th>
                                    <th>Email</th>
                                    <th>Address</th>
                                    <th>Created At</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orders.map(order => (
                                    <tr key={order._id}>
                                        <td>{order._id}</td>
                                        <td>{order.productId}</td>
                                        <td>{order.dressTitle}</td>
                                        <td>{order.quantity}</td>
                                        <td>{order.price}</td>
                                        <td>{order.email}</td>
                                        <td>{order.address}</td>
                                        <td>{order?.createdAt?.slice(0, 10)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <Loader />
                )
            }
        </>
    )
}
